// Framework-agnostic layout of the referral PDF: style metrics derived from the
// jsPDF document, and the top-to-bottom assembly of the drawing components.
// The Angular 'PDF' service (services/pdf.js) owns the async data/image loading.

const calculateStyles = (pdf) => {
  const pagePaddings = {
    x: 10, // left & right
    y: 10 // top & bottom
  };

  var headerDatePaddings = {
    x: 140,
    y: -5
  };

  var headerHeight = 20;

  var headerColor = {
    r: 52, g: 73, b: 94
  };

  var headerFontColor = {
    r: 255, g: 255, b: 255
  };
  var headerFontSize = 12;

  // 'default' font styles, that are used in the majority of sections
  // these styles are also used as best guess when 'restoring' styles (e.g. see appendHeader)
  var fontSize = 10;

  // small font gray texts: images available below, check more at the site, etc.
  var auxiliaryFontSize = 8;

  var auxiliaryFontColor = {
    r: 150, g: 150, b: 150
  };

  var pageSizes = {
    width: pdf.internal.pageSize.getWidth(),
    height: pdf.internal.pageSize.getHeight(),
    centerHorizontal: pdf.internal.pageSize.getWidth() / 2
  };
  const colPadding = 10;  // horizontal, between the two columns
  const halfSizeColWidth = (pageSizes.width - 2 * pagePaddings.x - colPadding) / 2;
  const fontColor = {
    r: 0, g: 0, b: 0
  };

  const dpi = 96;
  const pixelsToMm = (pixels) => pixels * 25.4 / dpi;

  const logo = {
    padding: 2,
  }

  // All sizes in mm
  return {
    pixelsToMm,
    pagePaddings,
    blocksPadding: 3,  // vertical, between info blocks; line separator is 2X this size
    addressPaddingX: 5,  // x-padding under 'Referred' titles
    headerHeight,
    headerColor,
    headerFontSize,
    headerFontSizeMm: headerFontSize / pdf.internal.scaleFactor,
    headerFontColor,
    headerDatePaddings,
    fontSize,
    fontSizeMm: fontSize / pdf.internal.scaleFactor,
    auxiliaryFontSize,
    auxiliaryFontSizeMm: auxiliaryFontSize / pdf.internal.scaleFactor,
    auxiliaryFontColor,
    fullSizeColWidth: pageSizes.width - 2 * pagePaddings.x,
    halfSizeColWidth,
    secondColX: pagePaddings.x + halfSizeColWidth + colPadding,  // where second column starts
    pageSizes,
    fontColor,
    thumbnailSquareSize: 30,  // width & height of the thumbnail square
    thumbnailTextPaddingX: 5,  // from the thumbnail itself
    logo
  }
};

// Main PDF building function
const assemblePdf = ({ jsPDF, components, data, forPatient }) => {
  const pdf = new jsPDF('p', 'mm', 'letter');
  const styles = calculateStyles(pdf);

  let caret = components.appendHeader(pdf, styles, data.referralDate);
  caret = components.appendPractices(pdf, styles, caret, data.originalPracticeData, data.destinationPracticeData);
  caret = components.leftHorizontalSeparator(pdf, styles, caret);

  let qrCodeCaret = caret;
  caret = components.appendPatientTextData(pdf, styles, caret, data.patientData);
  caret = components.appendProcedureData(pdf, styles, caret, data.procedureData);

  let caretRight = components.appendQRCode(pdf, styles, qrCodeCaret, data.destinationPracticeData);
  caret = Math.max(caret, caretRight);

  // vertical line next to QR code
  components.verticalSeparator(pdf, styles.pageSizes, qrCodeCaret, caret - styles.blocksPadding);
  caret = components.appendLineSeparator(pdf, styles, caret); // horizontal line below

  if (forPatient) {
    caret = components.appendThumbnails(pdf, styles, caret, data, data.attachments);
    caret = components.appendBottomText(pdf, styles, caret);
  } else {
    caret = components.appendAllNotes(pdf, styles, caret, data, data.notes);
    caret = components.appendAllImages(pdf, styles, caret, data, data.attachments);
  }

  return pdf;
};

module.exports = { calculateStyles, assemblePdf };
